module.exports = __webpack_public_path__ + "img/5.b707cb46.png";